import React from 'react'
import email from '../../img/email.svg';

const EmailSVG = ({addClass}) => (
  <svg className={addClass}>
    <use xlinkHref={`#${email.id}`} />
  </svg>
);

export default EmailSVG